import React from 'react';
import Logo from '../../../../../../resources/imgs/logo-lado-bom-seguros.svg';
import Button from '../../../../../../components/Button';

interface CapitalizationBannerProps {
  handleOnclick: () => void;
}

const CapitalizationBanner: React.FC<CapitalizationBannerProps> = ({ handleOnclick }) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <img src={Logo} style={{ width: '135px' }} />
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'start'
        }}
      >
        <div style={{ fontWeight: 'bold', color: '#59249B', fontSize: '17px' }}>
          Análise recusada?
        </div>
        <div style={{ fontWeight: 'normal', fontSize: '14px' }}>
          Garantia de recebimento do aluguel e encargos, sem burocracia.
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <Button
          fluid
          color="green"
          type={'button'}
          size={'mini'}
          text="Contratar título"
          style={{
            margin: '0.5em 0em',
            paddingLeft: '36px',
            paddingRight: '36px'
          }}
          onClick={() => handleOnclick()}
        />
      </div>
    </>
  );
};

export default CapitalizationBanner;
